<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <van-form @submit="handlerSubmit" :model="formData" @failed="handleFailed">
      <van-field
        required
        name="radio"
        label="本年度是否参加过培训"
        class="radioFlex"
        :rules="[
          {
            required: true,
            message: '请选择本年度是否参加过培训',
          },
        ]"
      >
        <template #input>
          <van-radio-group
            v-model="formData.train"
            direction="horizontal"
            v-for="item in yORn"
            v-bind:key="item.key"
            @change="radioChange($event, 'train', clearTrain)"
          >
            <van-radio :name="item.key" checked-color="#ff6865">{{
              item.value
            }}</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <div v-if="formData.train == 1">
        <template v-for="(itemT, index) in formData.items" :key="index">
          <van-field
            required
            v-model="itemT.trainName"
            clearable
            label="培训名称"
            placeholder="请填写培训名称"
            :rules="[{ required: true, message: '请填写培训名称' }]"
          />

          <van-field
            required
            name="radio"
            label="培训级别"
            :rules="[
              {
                required: true,
                message: '请选择培训级别',
              },
            ]"
          >
            <template #input>
              <van-radio-group
                v-model="itemT.trainLevel"
                direction="horizontal"
                v-for="item in trainLevelList"
                v-bind:key="item.key"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
            required
            name="radio"
            label="主办单位"
            :rules="[
              {
                required: true,
                message: '请选择主办单位',
              },
            ]"
          >
            <template #input>
              <van-radio-group
                v-model="itemT.organizer"
                direction="horizontal"
                v-for="item in organizerList"
                v-bind:key="item.key"
              >
                <van-radio :name="item.key" checked-color="#ff6865">{{
                  item.value
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
            required
            v-model="itemT.classHours"
            clearable
            type="digit"
            label="学时"
            placeholder="请填写学时"
            :rules="[
              { required: true, message: '请填写学时' },
              { validator, message: '请填写学时' },
            ]"
          />

          <datetime-picker
            :value="itemT.trainDate"
            title="培训日期"
            type="year-month"
            :callback="(val) => handlerSelect(index, 'trainDate', val)"
            :isRequired="trainDateFlag"
          />
          <div class="btn_r red1" v-if="formData.items.length > 1">
            <van-button type="danger" @click="delTrainItem(index)"> 删除 </van-button>
          </div>
        </template>

        <div class="btn_r red">
          <van-button type="warning" @click="addTrainItem"> 添加 </van-button>
        </div>
      </div>

      <!--登录按钮-->
      <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit" class="btn btn_dl">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { reactive, toRefs, watch, onMounted, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";
import headers from "@/components/Header";
import datetimePicker from "@/components/DatePicker";
import { yORn, trainLevelList, organizerList } from "@/common/js/field";
import { Dialog, Toast } from "vant";
import { addForm, getsubmitData, editForm } from "@/service/form";
import {
  getKey,
  encrypt,
  rsaUtil,
  serverPublicKey,
  radioChange,
  validator,
} from "@/common/js";
export default {
  name: "addForm3",
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let genKeyPair = rsaUtil.genKeyPair();
    window.jsPublicKey = genKeyPair.publicKey;
    window.jsPrivateKey = genKeyPair.privateKey;

    const state = reactive({
      formId: 5,
      isTrain: false,
      trainDateFlag: false,
      formData: {
        train: null,
        items: [
          {
            trainName: null,
            trainLevel: null,
            organizer: null,
            classHours: 0,
            trainDate: null,
          },
        ],
      },
    });
    onMounted(async () => {
      const { type, isTrain } = route.query;
      if (type == 1) {
        getInfo();
      }
      // 新添加时 不需要再重新选择是否参加过培训
      if (isTrain) {
        state.formData.train = 1;
      }
    });
    const getInfo = async () => {
      const { id } = route.query;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      console.log("data", data);
      if (code == 10000 && data) {
        const newObj = { formData: {} };
        state.id = data.id;
        state.formId = data.formId;

        for (const i of data.list) {
          let val = i.value;
          if (i.fieldCode == "train" || i.fieldCode == "items") {
            newObj.formData[i.fieldCode] = val;
          } else {
            newObj[i.fieldCode] = val;
          }
        }
        for (let i in newObj.formData.items) {
          let val = newObj.formData.items[i].trainDate;
          val = val * 1000;
          newObj.formData.items[i].trainDate = val;
        }
        //   赋值
        Object.assign(state, newObj);
      }
    };
    watch(
      () => state.formData,
      () => {
        if (state.formData.item) {
          for (let i = 0; i < state.formData.items.length; i++) {
            let item = state.formData.items[i];
            if (typeof item.classHours == "string") {
              item.classHours = Number(item.classHours);
            }
          }
        }
      },
      { deep: true }
    );

    // 选择字段回调赋值
    const handlerSelect = (index, key, value) => {
      state.formData.items[index].trainDate = value;
      if (key == "trainDate") {
        state.trainDateFlag = false;
      }
    };

    // 动态添加培训内容
    const addTrainItem = () => {
      state.formData.items.push({
        trainName: null,
        trainLevel: null,
        organizer: null,
        classHours: 0,
        trainDate: null,
      });
    };
    const delTrainItem = (index) => {
      state.formData.items.splice(index, 1);
    };

    const goBack = () => {
      router.go(-1);
    };
    const goTo = () => {
      // console.log("goTo");
      router.push({ path: "/info/wtg" });
    };
    const handleFailed = () => {
      console.log('handleFailed')
       Dialog.alert({
        message: "请填写所有必填信息* ~",
      }).then(() => {
        console.log('--33--')
      });
    }
    const handlerSubmit = () => {
      const {
        formData: { train, items },
      } = state;
      if (train == 1) {
        let flag = true;
        for (let i of items) {
          if (!i.trainDate) {
            state.trainDateFlag = true;
            flag = false;
            break;
          }
        }
        if (!flag) {
          return false;
        }
      }

      Dialog.confirm({
        title: "提示",
        message: "你确定要提交吗？",
      })
        .then(() => {
          proxy.$showLoading();
          add(state);
        })
        .catch(() => {
          // on cancel
        });
    };
    const add = async (values) => {
      let arr = [];
      const { type, id } = route.query;
      let data = {
        formId: 4,
        list: [],
      };
      let fn = addForm;
      if (type == 1) {
        data.id = id;
        fn = editForm;
      }
      for (let i in values.formData.items) {
        let val = values.formData.items[i].trainDate;
        if (val && val.toString().length > 10) {
          val = val / 1000;
        }
        values.formData.items[i].trainDate = val;
      }

      // const whiteList = ["trainDateFlag", "isTrain"];
      Object.keys(values.formData).forEach(function (item) {
        let obj = {
          fieldCode: item,
          value: values.formData[item],
        };
        if (!(values.formData.train == 2 && item == "items")) {
          if (values.formData[item] || values.formData[item] == 0) {
            arr.push(obj);
          }
        }
      });

      data.list = arr;
      console.log("data", data);

      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(data, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
        // publicKey: window.jsPublicKey //前端公钥
      };
      try {
        const res = await fn(param);
        if (res.code === 10000) {
          proxy.$closeLoading();
          Dialog.alert({
            message: "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~",
          }).then(() => {
            goTo();
          });
        } else {
          proxy.$closeLoading();
        }
      } catch (error) {
        proxy.$closeLoading();
        if (error.code == 30003) {
          Toast.fail("同年只能填写一条数据");
        }
      }
    };
    const clearTrain = (val) => {
      if (val == 2) {
        state.formData = {
          train: 2,
          items: [
            {
              trainName: null,
              trainLevel: null,
              organizer: null,
              classHours: 0,
              trainDate: null,
            },
          ],
        };
      }
    };

    return {
      ...toRefs(state),
      yORn,
      trainLevelList,
      organizerList,
      goBack,
      handlerSubmit,
      handlerSelect,
      radioChange,
      clearTrain,
      validator,
      addTrainItem,
      delTrainItem,
      handleFailed,
    };
  },
  components: {
    headers,
    datetimePicker,
  },
};
</script>
<style lang="less" scoped>
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}
:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-radio-group--horizontal) {
  padding: 0.188rem 0;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
.btn_r {
  margin: 0.12rem;
  display: flex;
  justify-content: flex-end;
}
.red {
  button {
    // border: 0.02667rem solid #ff6865 !important;
    // color: #ff6865;
    height: 0.9rem;
  }
}
.red1 {
  button {
    // border: 0.02667rem solid #dedede !important;
    // color: #dedede;
    // background-color: #fff;
    height: 0.9rem;
  }
}
</style>
